import * as React from "react";
import {cs} from "../../../../../../../../../react/chain-services";
import {cx} from "emotion";
import "./streets-box.scss";
import {UseState} from "../../../../../../../../../react/use-state";
import {chain} from "../../../../../../../../../utils/fs";
import {SearchInput} from "../../../../../../../common/design2/search-input/search-input";
import {isApiTrue} from "../../../../../../../../../logic/is-api-true";
import {scc} from "../../../../../../../../../react/state-cascade-change";
import {EditActionInTable} from "../../../../../../../common/design2/data-table-ui/edit-action-in-table/edit-action-in-table";
import {sum} from "../../../../../../../../../utils/collections";
import {PageList} from "../../../../../../../common/design2/pagination-ui/page-list/page-list";
import {Table} from "./table/table";
import {stateChangeNestedValue} from "../../../../../../../../../react/state-change-nested-value";
import {plural} from "../../../../../../../../language/plural";
import {ErrorHighlighter} from "../../../../../../../../light/error-highlighter";
import {bindInput} from "../../../../../../../../../react/bind-input";
import {isSpecialKey} from "../../../../../../../../../utils/browser/is-special-key";

export const StreetsBox = ({data, searchState, next: rootNext}) => cs(
    ["filter", (_, next) => UseState({next})],
    ["match", ({filter}, next) => next(!filter.value? (() => true) : (() => {
        const lowerCase = filter.value.toLowerCase();
        return ({street}) => (
            street.address.toLowerCase().includes(lowerCase) ||
            ("" + street.zip_code).toLowerCase().startsWith(lowerCase)
        );
    })())],
    ["records", ({}, next) => next(data.value?.map((r, i) => ({
        ...r,
        setExcluded: (excluded) => stateChangeNestedValue(data, [i, "excluded"], () => excluded),
    })))],
    ["filteredRecords", ({records, match}, next) => next(chain(
        records,
        (_) => _?.filter(match),
    ))],
    ["editing", (_, next) => UseState({
        initValue: {
            editing: false,
            hasError: {
                min: false,
                max: false,
            }
        },
        next
    })],
    ["eh", (_, next) => ErrorHighlighter({next})],
    ({filter, records, filteredRecords, match, editing, eh}) => rootNext({
        highlightErrors: () => {
            eh.start();
        },

        valid: !editing.value.editing && !editing.value.hasError?.min && !editing.value.hasError?.max,

        render: () => (
            <div className={cx("streets-box-1il", eh.css)}>
                <div className="controls">
                    {SearchInput({
                        state: filter,
                        placeholder: "Search Street",
                        text: filter.value && <>Found <b>{filteredRecords.length}</b> {plural("street", filteredRecords.length)}</>,
                        xdQaName: "Build Street List Search Street",
                    })}
                </div>

                {Table({
                    count: {
                        selected: records.filter((r) => !r.excluded).length,
                        total: records.length,
                    },
                    masterCheckbox: (
                        !filteredRecords.find((r) => !r.excluded) ? {
                            checked: false,
                            onClick: () => scc(data, "[*].excluded", (_, {}, {0: r}) => match(r) ? false : _),
                        } : filteredRecords.find((r) => r.excluded) ? {
                            checked: "midway",
                            onClick: () => scc(data, "[*].excluded", (_, {}, {0: r}) => match(r) ? false : _),
                        } : {
                            checked: true,
                            onClick: () => scc(data, "[*].excluded", (_, {}, {0: r}) => match(r) ? true : _),
                        }
                    ),
                    filteredRecords,
                    renderActions: {
                        editAction: (r) => (
                            EditActionInTable({
                                active: searchState.value?.type === "street" && searchState.value.streetKey === r.key,
                                onClick: () => searchState.onChange({type: "street", streetKey: r.key}),
                                xdQaName: "Build Street List "+r.street.address,
                            })
                        ),
                        startHouseAction: (r) => (
                            searchState.value?.type === "street" && searchState.value.streetKey === r.key ? (
                                EditHouseNumberAction({data, street: r, location: "min", editing})
                            ) : (
                                r.street.min
                            )
                        ),
                        endHouseAction: (r) => (
                            searchState.value?.type === "street" && searchState.value.streetKey === r.key ? (
                                EditHouseNumberAction({data, street: r, location: "max", editing})
                            ) : (
                                r.street.max
                            )
                        ),
                    },
                    getFooter: ({pagination}) => (
                        <div className="footer-4fr">
                            <div className="summary">
                                <table>
                                    <tbody>
                                    <tr className="total-addresses">
                                        <td className="label" xd-qa-type="label" xd-qa-name="Build Street List Total Addresses">
                                            Total Addresses
                                        </td>
                                        <td className="value" xd-qa-type="label" xd-qa-name="Build Street List Total Addresses Amount">
                                            {sum(data.value, (r) => (
                                                r.excluded ? 0 : (
                                                    r.addresses.filter((a) => isApiTrue(a.display_address)).length
                                                )
                                            ))}
                                        </td>
                                    </tr>
                                    <tr className="total-streets">
                                        <td className="label" xd-qa-type="label" xd-qa-name="Build Street List Total Streets">
                                            Total Streets
                                        </td>
                                        <td className="value" xd-qa-type="label" xd-qa-name="Build Street List Total Streets Amount">
                                            {sum(data.value, (r) => r.excluded ? 0 : 1)}
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>

                            {pagination.active && (
                                <div className="pagination">
                                    {PageList({...pagination, xdQaNamePrefix: "Build Street List Street"})}
                                </div>
                            )}

                            <div className="actions">
                                <button {...{
                                    disabled: searchState.value?.type === "all",
                                    onClick: () => searchState.onChange({type: "all"}),
                                    "xd-qa-type": "button",
                                    "xd-qa-name": "Build Street List VIEW ALL ADDRESSES",
                                }}>
                                    VIEW ALL ADDRESSES
                                </button>
                            </div>
                        </div>
                    ),
                })}
            </div>
        )
    }),
);

const EditHouseNumberAction = ({data, street, location, editing}) => cs(
    ["typing", (_, next) => UseState({next})],
    ["focus", (_, next) => UseState({next})],
    ["records", ({}, next) => next(
            street.addresses.map((r1) => r1.address.split(' ')[0])
    )],
    ({typing, records, focus}) => (
        <input {...{
            ...bindInput({
                ...typing,
                value: typing.value ?? street.street[location],
            }),
            placeholder: street.street[location],
            className: cx({
                focus: focus.value,
                hasError: editing.value.hasError[location],
            }),
            onKeyDown: (e) => {
                if (isSpecialKey(e) || e.key?.length > 1) {

                } else if (isNaN(+e.key)) {
                    e.preventDefault();
                }
            },
            onKeyUp: () => {
                if (!typing.value || street.street[location] == typing.value) {
                    editing.onChange({
                        ...editing.value,
                        editing: false,
                    });
                } else if (typing.value && !editing.value) {
                    editing.onChange({
                        ...editing.value,
                        editing: true,
                    });
                }
                if (typing.value && isNaN(typing.value)) {
                    if (!editing.value.hasError[location]) {
                        editing.onChange({
                            ...editing.value,
                            hasError: {
                                ...editing.value.hasError,
                                [location]: true,
                            }
                        });
                    }
                } else if ((!typing.value || !isNaN(typing.value)) && editing.value.hasError[location]) {
                    editing.onChange({
                        ...editing.value,
                        hasError: {
                            ...editing.value.hasError,
                            [location]: false,
                        }
                    });
                }
            },
            onFocus: () => {
                focus.onChange(true);
            },
            onBlur: () => {
                focus.onChange(false);
                if (typing.value) {
                    if (!isNaN(typing.value)) {
                        let closestHouse = 0;
                        if (records.indexOf(typing.value) !== -1) {
                            closestHouse = typing.value;
                        } else {
                            let sortedRecords = [].concat(records, typing.value).sort((a, b) => a - b);
                            if (location === "min") {
                                closestHouse = sortedRecords[sortedRecords.indexOf(typing.value) + 1];
                            } else {
                                closestHouse = sortedRecords[sortedRecords.indexOf(typing.value) - 1];
                            }
                        }
                        
                        if (closestHouse != street.street[location]) {
                            let value = 0;
                            let updateRecords = [];
                            if (location === "min" && +closestHouse <= +street.street.max) {
                                if (+closestHouse < +street.street.min) {
                                    value = 1;
                                    updateRecords = records.filter((house) => +house >= +closestHouse && +house < +street.street.min);
                                } else {
                                    value = 0;
                                    updateRecords = records.filter((house) => +house < +closestHouse);
                                }
                            } else if (location === "max" && +closestHouse >= +street.street.min) {
                                if (+closestHouse > +street.street.max) {
                                    value = 1;
                                    updateRecords = records.filter((house) => +house <= +closestHouse && +house > +street.street.max);
                                } else {
                                    value = 0;
                                    updateRecords = records.filter((house) => +house > +closestHouse);
                                }
                            } else {
                                typing.onChange(null);
                                editing.onChange({
                                    ...editing.value,
                                    editing: false,
                                });
                                return;
                            }
                            const streetIndex = data.value.findIndex((s) => s.key === street.key);
                            setExcludedRecords(value, {
                                records: updateRecords,
                                data,
                                streetIndex
                            });
                            stateChangeNestedValue(data, [streetIndex, "street", location], () => closestHouse);
                        }
                        typing.onChange(null);
                        editing.onChange({
                            ...editing.value,
                            editing: false,
                        });
                    }
                } else if (typing.value === "") {
                    typing.onChange(null);
                    editing.onChange({
                        ...editing.value,
                        editing: false,
                    });
                }
            },
        }}/>
    ),
)

const setExcludedRecords = (value, {records, data, streetIndex}) => {
    scc(data, `[${streetIndex}]addresses[*].display_address`, (_, {}, {2: address}) => (
        !records.find((house) => house === address.address.split(' ', 1)[0]) ? _ : value
    ))
};